import { Badge, BadgeVariant } from '@moment/design-system-ui/badge'

import { ManagementType } from '@/types/api/accounts'
import { PLACEHOLDER } from '@/utils/presentation/formatting'

interface ManagementTypeBadgeProps {
  managementType: ManagementType
}

export function ManagementTypeBadge({
  managementType,
}: ManagementTypeBadgeProps) {
  switch (managementType) {
    case ManagementType.Sma:
      return <Badge variant={BadgeVariant.Neutral}>SMA</Badge>
    case ManagementType.Uma:
      return <Badge variant={BadgeVariant.Neutral}>UMA</Badge>
    default:
      return PLACEHOLDER
  }
}
